import React from "react";
import DrinkCard from "./DrinkCard";
import CardsGrid from "../CardsGrid";

const DrinksGrid = ({ drinks, placeholderText }) => {
  const createDrinkCards = () => {
    return drinks.map(drink => {
      return <DrinkCard key={drink._id} drink={drink} />;
    });
  };

  return (
    <CardsGrid cards={createDrinkCards()} placeholderText={placeholderText} />
  );
};

DrinksGrid.defaultProps = {
  placeholderText: "No drinks found"
};

export default DrinksGrid;
